// extracted by mini-css-extract-plugin
export default {"sbutton_open":"Button_sbutton_open__L9OO6","sbutton_busing":"Button_sbutton_busing__Wr7TW","triangle":"Button_triangle__aE3ap","btn_hover":"Button_btn_hover__Txjo1"};